import { createFileRoute } from '@tanstack/react-router';
import { DocPage } from '@/components/docs/DocPage';
import { segurancaDocTitle, segurancaDocDescription, segurancaDocSections } from '@/content/docs/seguranca';

export const Route = createFileRoute('/_admin/docs/seguranca')({
  component: DocsSegurancaPage,
});

function DocsSegurancaPage() {
  return (
    <DocPage
      title={segurancaDocTitle}
      description={segurancaDocDescription}
      sections={segurancaDocSections}
    />
  );
}
